import cn from 'client/utils/cn';

import React, { Component } from 'react';

import Breadcrumbs from 'client/components/breadcrumbs';
import LangContext from 'client/utils/lang-context';

import { PageAboutProps } from 'client/bundles/types';

import AboutCard from './about-card';
import './index.css';

const b = cn('about');
const bPageTitle = cn('page-title');

interface Props {
    aboutData?: PageAboutProps;
}

class About extends Component<Props> {
    static contextType = LangContext;

    render() {
        if (!this.props.aboutData) {
            return;
        }

        const { title, advantages } = this.props.aboutData;
        const { dictionary } = this.context;

        return (
            <div className={b()}>
                <Breadcrumbs link="/" text={dictionary.home} />

                <h1 className={bPageTitle({ type: 'border' })}>{title}</h1>
                <div className={b('content')}>
                    {advantages.map(({ id, ...props }) => <AboutCard key={id} {...props} />)}
                </div>
            </div>
        );
    }

}

export default About;
